import { render, staticRenderFns } from "./OverlayStage.vue?vue&type=template&id=284122e2&scoped=true"
import script from "./OverlayStage.vue?vue&type=script&lang=js"
export * from "./OverlayStage.vue?vue&type=script&lang=js"
import style0 from "./OverlayStage.vue?vue&type=style&index=0&id=284122e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284122e2",
  null
  
)

export default component.exports